<div *ngLet="data.existingSignRequestData$ | async as existingSignRequestData" class="dialogCustom--maxHeight">
  <div mat-dialog-title>
    <div data-testId="title" class="h4 mb-0">{{data.title}}</div>
    <button data-testId="close" mat-icon-button (click)="onCancel()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="noPadding digitalSignatureContent">
    <div class="bg-light p-3">
      <mat-card class="noPadding mb-0">
        <section class="section section--wShadow">
          <div class="alert w-100">
            <h4>
              <span i18n="@@dpr.digitalSignatureModal.titleESign" class="align-middle">E-sign</span>
              <app-chip
                *ngIf="data.dprCard?.hasActiveSignRequest"
                class="ml-2 align-middle"
                [icon]="existingSignRequestData | eSignStatusIcon"
                [color]="existingSignRequestData | eSignStatusColor"
                [label]="existingSignRequestData | eSignStatusText"
              ></app-chip>
            </h4>
            <div data-testId="description">
              <span i18n="@@dpr.digitalSignatureModal.txtESignEmailsAfterSend">
                The signer emails cannot be changed after sending the E-sign request.
              </span>
              <br />
              <span
                *ngIf="!data.dprCard?.hasActiveSignRequest"
                i18n="@@dpr.digitalSignatureModal.txtESignEmailsMakeSure"
              >
                Make sure all email addresses are entered correctly.
              </span>
            </div>

            <div *ngIf="data.dprCard.hasImagesToPrint && !data.dprCard.hasActiveSignRequest">
              <hr />
              <h6 i18n="@@dpr.digitalSignatureModal.txtOptions">Options</h6>
              <mat-checkbox
                data-testId="set-print-images-high-resolution"
                color="primary"
                [(ngModel)]="isDownloadImageAtOriginalSize"
                i18n="@@dpr.digitalSignatureModal.lblPrintImagesInHighResolution"
              >
                Print images in high resolution in PDF document
              </mat-checkbox>
            </div>
          </div>
        </section>
      </mat-card>
    </div>

    <ng-container *ngLet="{gridData: gridData$ | async, predefinedChanges: predefinedChanges$ | async } as observables">
      <app-grid
        *ngIf="isInitialized && observables.gridData && observables.predefinedChanges"
        [data]="observables.gridData"
        [options]="gridOptions"
        [columns]="gridColumns"
      ></app-grid>
    </ng-container>
  </div>

  <div mat-dialog-actions>
    <button
      *ngIf="!data.dprCard.hasActiveSignRequest"
      data-testId="send-esign-request"
      mat-flat-button
      color="primary"
      (click)="onSend()"
      cdkFocusInitial
    >
      <mat-icon svgIcon="send"></mat-icon>
      <span i18n="@@dpr.digitalSignatureModal.btnSendRequest">Send e-sign request</span>
    </button>

    <button
      *ngIf="data.dprCard.hasActiveSignRequest && existingSignRequestData?.status !== SignRequestStatus.Signed"
      data-testId="cancel"
      mat-flat-button
      color="warn"
      (click)="onCancelRequest()"
    >
      <mat-icon svgIcon="close"></mat-icon>
      <span i18n="@@dpr.digitalSignatureModal.btnCancelRequest">Cancel e-sign request</span>
    </button>

    <button mat-button color="primary" (click)="onCancel()">Close</button>
  </div>
</div>

<ng-template #statusTemplate let-context>
  <app-chip
    [icon]="context.data | eSignStatusIcon"
    [color]="context.data | eSignStatusColor"
    [label]="context.data | eSignStatusText"
  ></app-chip>
</ng-template>

<ng-template #statusChangedOnTemplate let-context>
  <ng-container *ngLet="context.data | eSignStatusChange : documentStatusChangedOn as statusChangeDate">
    <span *ngIf="statusChangeDate">{{statusChangeDate | toUtcDateTime}} UTC</span>
  </ng-container>
</ng-template>
